import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  modal: {
    width: 504,
  },
});
